module.exports = __webpack_public_path__ + "static/media/FACEBOOK_Korea Exhibition PR Video_Dice and Robert- Korean Subtitle.44a2e764.mp4";